module.exports = __webpack_public_path__ + "static/media/avatar_2.ee0895f4.svg";